import { render, staticRenderFns } from "./CompanyTarget.vue?vue&type=template&id=65b644fb&scoped=true"
import script from "./CompanyTarget.vue?vue&type=script&lang=js"
export * from "./CompanyTarget.vue?vue&type=script&lang=js"
import style0 from "./CompanyTarget.vue?vue&type=style&index=0&id=65b644fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b644fb",
  null
  
)

export default component.exports